import config from "./config/exam";
import axios from "@/utils/request";
export const getFileUpload = (params) =>
  axios.post(`/third/api/tencentUpload/upload/file/local`, params);
export const getQuestion = (params) => axios.post(config.getQuestion, params);
export const login = (params) => axios.post(config.login, params);
export const examCenterList = (params) =>
  axios.post(config.examCenterList, params);
export const oneQuestionSumit = (params) =>
  axios.post(config.oneQuestionSumit, params);
export const submitTest = (params) =>
  axios.post(config.submitTest, params);
export const idCardInfoQuery = (params) =>
  axios.post(config.idCardInfoQuery, params);
export const subjectCodeCheck = (params) =>
  axios.post(config.subjectCodeCheck, params);
